var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"offer-single-page"},_vm._l((_vm.pageSports),function(idSport){return _c('SportWrap',{key:idSport,attrs:{"idSport":idSport,"configId":_vm.configId,"matches":_vm.matchesBySport(idSport)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }